export class AreaModel {
  id: number;
  projectId: number;
  name: string;
  description: string;
  defaultArea: boolean = false;
  updateBounds: boolean = true;
  latitude : number;
  longitude : number;
  zoom: number;

  static map(area: any): AreaModel{
    var model = new AreaModel();
    model.id = area.id;
    model.projectId = area.projectId;
    model.name = area.name;
    model.description = area.description;
    model.defaultArea = area.defaultArea;
    model.updateBounds = area.updateBounds;
    model.latitude = area.latitude;
    model.longitude = area.longitude;
    model.zoom = area.zoom;
    return model;
  };


  static mapToService(model: AreaModel): any{
    var area : any = new Object;
    area.id = model.id;
    area.projectId = model.projectId;
    area.name = model.name;
    area.description = model.description;
    area.defaultArea = model.defaultArea;
    area.updateBounds = model.updateBounds;
    area.latitude = model.latitude;
    area.longitude = model.longitude;
    area.zoom = model.zoom;
    return area;
  }
}
